Mmg.addShortcode(

  /**
   * @param {string} shortcodeName The name of the shortcode
   * @param {string} selector The selector used to locate this shortcode in the DOM
   * @param {callable} callback The callback function applied to every element matching the selector
   */
  'test_scores',
  '.sc-test-scores',

  /**
   *
   * Shortcode callback
   *
   * The shortcode callback receives the following parameters:
   *
   * @param {Element} el The shortcode's DOM element
   * @param {object} model The data model passed to the shortcode instance in data-json attribute
   * @param {jQuery} $ The callback function applied to every element matching the selector
   * @param {string} selector The shortcode selector that was passed to addShortcode
   * @param {string} className The name of the shortcode class
   */
  (el, model, $, selector, className) => {
  // Widget Declarations
  const $this = $(el);
  const $navTabs = $this.find(`${selector}__nav-tabs`);
  const $navScrollPrev = $this.find(`${selector}__nav-scroll--prev`);
  const $navScrollNext = $this.find(`${selector}__nav-scroll--next`);
  const tabWidth = $navTabs.find(`${selector}__nav-link`).first().outerWidth(true);
  let scrollLeft = 0;
  let maxScrollLeft = 0;

  // Entities are rendered in a fixed order/color so identity never shifts between charts.
  const configurationBySeries = {
    school: {
      name: 'School',
      itemStyle: {color: '#d92228'},
      lineStyle: {color: '#d92228', type: 'solid'},
    },
    school_district: {
      name: 'District',
      itemStyle: {color: '#1e61d9'},
      lineStyle: {color: '#1e61d9', type: 'dashed'},
    },
    state: {
      name: 'State',
      itemStyle: {color: '#333333'},
      lineStyle: {color: '#333333', type: 'dotted'},
    },
  };
  const baseConfiguration = {
    tooltip: {
      trigger: 'axis',
      className: `${className}__tooltip`,
    },
    legend: {
      type: 'scroll',
      bottom: 0,
      data: ['School', 'District', 'State'],
    },
    grid: {
      left: 0,
      right: '4%',
      top: '8%',
      bottom: '22%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLabel: {
        rotate: 45,
      },
    },
    yAxis: {
      type: 'value',
      show: false,
    },
    series: {
      type: 'line',
      showSymbol: false,
    },
  };

  /**
   * Initialize the widget
   */
  (function init(){
    render();
    addEvents();
    initNavScrollButtons();
  })();

  /**
   * Handle UI events
   */
  function addEvents() {
    $this.on('shown.bs.tab', render);
    new MutationObserver(render).observe(el, {
      attributeFilter: ['data-echarts-loaded'],
    });
    $.breakpoint('change', () => {
      render();
      initNavScrollButtons();
    });
    $navTabs.on('scroll', syncScrollPosition);
    $navScrollPrev.on('click', event => scrollNavTabs(event, -1));
    $navScrollNext.on('click', event => scrollNavTabs(event, 1));
  }

  /**
   * Keep scrollLeft in sync with native scrolling (trackpad/touch).
   */
  function syncScrollPosition() {
    scrollLeft = Math.round($navTabs.scrollLeft());
    syncNavScrollButtons();
  }

  /**
   * Scroll the grade tabs one tab's width in the given direction.
   *
   * @param {Event} event
   * @param {number} direction -1 to scroll left/prev, 1 to scroll right/next
   */
  function scrollNavTabs(event, direction) {
    event.preventDefault();

    if (direction < 0 && scrollLeft <= 0) {
      return;
    }
    if (direction > 0 && scrollLeft >= maxScrollLeft) {
      return;
    }

    scrollLeft = Math.max(
      0,
      Math.min(maxScrollLeft, scrollLeft + (tabWidth * direction))
    );
    $navTabs[0].scrollLeft = scrollLeft;
    syncNavScrollButtons();
  }

  /**
   * Show the buttons only when the tabs overflow.
   */
  function initNavScrollButtons() {
    const nav = $navTabs[0];
    maxScrollLeft = nav.scrollWidth - nav.clientWidth;
    scrollLeft = Math.round($navTabs.scrollLeft());

    $navScrollPrev.toggle(maxScrollLeft > 0);
    $navScrollNext.toggle(maxScrollLeft > 0);

    if (maxScrollLeft > 0) {
      // tab is narrower now that the scroll buttons showed up
      maxScrollLeft = nav.scrollWidth - nav.clientWidth;
    }

    syncNavScrollButtons();
  }

  /**
   * Disable whichever side there's nothing left to scroll to.
   */
  function syncNavScrollButtons() {
    $navScrollPrev.toggleClass('disabled', scrollLeft <= 0);
    $navScrollNext.toggleClass('disabled', scrollLeft >= maxScrollLeft);
  }

  /**
   * Render the charts
   */
  function render() {
    // echarts is loaded by the core EchartsLoader
    if ($this.attr('data-echarts-loaded') !== 'true') {
      return;
    }

    const $charts = $this.find(`${selector}__chart:visible`);
    $charts.each(renderChart);
  }

  /**
   * Render each chart using the corresponding data.
   */
  function renderChart(index, $chart) {
    // Do not initialize the same chart more than once, simply resize
    if ($chart.getAttribute('shown')) {
      echarts.getInstanceByDom($chart).resize();
      return;
    }

    const target = $($chart).attr('data-target');
    const chartData = model.chartsData.find(item => item.chart_type === target);

    if (!chartData) {
      return;
    }

    const data = JSON.parse(chartData.json);

    const formattedSeries = Object.keys(configurationBySeries)
      .filter(key => data.series[key])
      .map(key => {
        const seriesConfig = {
          ...baseConfiguration.series,
          ...configurationBySeries[key],
          data: data.series[key].data,
        };
        if (seriesConfig.data.length === 1) {
          seriesConfig.showSymbol = true;
        }
        return seriesConfig;
      });

    const chart = echarts.init($chart);
    chart.setOption($.extend(
      true,
      // start from a clean object to avoid mutating shared configurations
      // merge from general to specific data/configurations
      {},
      baseConfiguration,
      data,
      {series: formattedSeries},
    ));
    $chart.setAttribute('shown', true);
  }
});
